import React from 'react';
import Logout from '../Logout';

const AuthContext = React.createContext({
    authenticated: false,
    token: null,
    Logout: () => {},
  });

export default AuthContext;